<script setup lang="ts">
const { fetchProducts } = useProductsStore()
const { getPrivateConversations } = useChatStore()
const { fetchNotificationsByUserId } = useNotificationStore()
const logger = useCanxLogger()
const { $pwa } = useNuxtApp()
const { status: authStatus } = useAuth()
const isVisible = ref(true)

onMounted(() => {
  document.addEventListener('visibilitychange', async () => {
    isVisible.value = document.visibilityState === 'visible'
  }, false)

  watchEffect(async () => {
    if (authStatus.value !== 'authenticated') return
    const np = await checkNotificationPermissions()
    if (np) {
      useFirebase().getFBToken()
    }
  })
})

const nuxtApp = useNuxtApp()
const { setPageLoading } = usePageStore()
nuxtApp.hook('page:finish', () => setPageLoading(false))

watchEffect(() => {
  if (isVisible.value && authStatus.value === 'authenticated') {
    fetchNotificationsByUserId()
  }
})

const checkNotificationPermissions = async () => {
  if (!('Notification' in window)) {
    logger.error('This browser does not support notifications.')
    return false
  }
  if (Notification.permission === 'granted') {
    logger.log('Notification permission already granted.')
    return true
  }
  if (Notification.permission === 'denied') {
    logger.error('Notification permission is already denied.')
    return false
  }
  logger.log('Requesting notification permission')
  return Notification.requestPermission().then(p => p === 'granted')
}

useTalkjsInitializer()
await Promise.all([
  fetchProducts(),
  getPrivateConversations(),
])
</script>

<template>
  <div
    id="default-layout"
    class="2xl:container mx-auto flex flex-col"
  >
    <CanxMenuBar class="mb-1" />
    <main class="h-full overflow-y-hidden bg-surface-10">
      <Card
        v-show="$pwa?.needRefresh"
        :pt-options="{ mergeProps: true }"
        :pt:root="{ class: 'm-2' }"
        :pt:content="{ class: 'flex flex-col items-center justify-center' }"
      >
        <template #content>
          <p class="m-0">
            New content available, click on reload button to update.
          </p>
          <Button
            class="mt-2 w-52"
            icon="pi pi-refresh"
            label="Reload"
            @click="$pwa?.updateServiceWorker()"
          />
        </template>
      </Card>
      <slot v-if="authStatus === 'authenticated'" />
    </main>
    <BottomFixedMenubar />
  </div>
</template>

<style>
html, body, #__nuxt, #default-layout {
  height: 100%;
}

#default-layout {
  min-height: 100%;
}
</style>
